import {
  X5LessonSnapshot,
  X6PageSnapshot,
  X7PushableBlockSnapshot,
  X8BlockSnapshot,
  X9ContentSnapshot
} from 'domain/index';
import { isNullOrUndefined, Writeable } from 'lib/helpers';
import { x9ClassroomHelper } from 'scenes/content/x9/common/x9-classroom-helper';
import { HomeworkKeyValuesStore } from './stores/HomeworkKeyValuesStore';

function prepareBlock(block: X8BlockSnapshot): X8BlockSnapshot {
  let result: Writeable<X8BlockSnapshot> = Object.assign({}, block);
  if (isNullOrUndefined(result.ContentSnapshots))
    result.ContentSnapshots = [];
  return result;
}

function preparePushableBlock(pushableBlock: X7PushableBlockSnapshot): X7PushableBlockSnapshot {
  let result: Writeable<X7PushableBlockSnapshot> = Object.assign({}, pushableBlock);
  if (isNullOrUndefined(result.BlockSnapshots))
    result.BlockSnapshots = [];
  else
    result.BlockSnapshots = result.BlockSnapshots.map(prepareBlock);
  return result;
}

function preparePage(page: X6PageSnapshot): X6PageSnapshot {
  let result: Writeable<X6PageSnapshot> = Object.assign({}, page);
  if (isNullOrUndefined(result.PushableBlockSnapshots))
    result.PushableBlockSnapshots = [];
  else
    result.PushableBlockSnapshots = result.PushableBlockSnapshots.map(preparePushableBlock);
  return result;
}

function prepareLesson(lesson: X5LessonSnapshot): X5LessonSnapshot {
  let result: Writeable<X5LessonSnapshot> = Object.assign({}, lesson);
  if (isNullOrUndefined(result.PageSnapshots))
    result.PageSnapshots = [];
  else
    result.PageSnapshots = result.PageSnapshots.map(preparePage);
  return result;
}

/******************************************************************************/
function* enumerateContentItems(lesson: X5LessonSnapshot):
  Generator<X9ContentSnapshot, void, void> {
  for (let page of lesson.PageSnapshots!)
    for (let pb of page.PushableBlockSnapshots!)
      for (let b of pb.BlockSnapshots!)
        for (let item of b.ContentSnapshots!)
          yield item;
}

function initializeLesson(store: HomeworkKeyValuesStore, lesson: X5LessonSnapshot) {
  for (let item of enumerateContentItems(lesson)) {
    x9ClassroomHelper.initState(store, item);
  }
}

class HomeworkUtilsClass {
  readonly prepareLesson = prepareLesson;
  readonly initializeLesson = initializeLesson;
}

export const HomeworkUtils = new HomeworkUtilsClass();
